import { styled } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: 350,
  marginLeft: theme.spacing(0.5, 1),
}));
